export enum EnglishNB_Survey1 {
  "I speak only English, or I speak English more proficiently than I speak any other language.",
  "I speak English and another language with equal proficiency.",
  "I speak another language with more proficiency than I speak English."
}

export enum EnglishNB_Survey2 {
  "I read only in English, or I read in English more proficiently than I do in any other language.",
  "I read in English and in another language with equal proficiency.",
  "I read in another language with more proficiency than I read in English."
}

export enum EnglishNB_Survey3 {
  "I write only in English, or I write in English better than I do in any other language.",
  "I write in English and in another language with equal proficiency.",
  "I write in another language with more proficiency than I write in English."
}

export enum EnglishNB_Survey4 {
  "I only speak English at home.",
  "I speak English and another language at home with equal proficiency.",
  "I speak a language other than English at home."
}

export enum EnglishNB_Survey5 {
  "I have not previously attended school in the United States.",
  "Less than one year",
  "One to four years",
  "Five years or more"
}

export enum Polish_Survey {
  "Yes",
  "No",
  "N/A"
}

export enum Spanish_Survey1 {

}

export enum Arabic_Survey2 {
  "1st year student",
  "2nd year student",
  "3rd year student",
  "4th year student",
  "Graduate student",
  "Other"
}

export enum Arabic_Survey10 {
  "Yes, I speak AND write in Urdu.",
  "No, I do not speak OR write in Urdu.",
  "I speak in Urdu.",
  "I write in Urdu."
}

export enum Arabic_Survey12 {
  "Yes, I speak AND write in Farsi.",
  "No, I do not speak OR write in Farsi.",
  "I speak in Farsi.",
  "I write in Farsi."
}

export enum Chinese_Survey8a {
  "Yes",
  "No",
  "Maybe"
}

export enum Chinese_Survey8b {
  "Yes",
  "No"
}

export enum Chinese_Survey9a {
  "Yes",
  "No"
}

export enum Chinese_Survey9b {
  "1 Year",
  "2 Years",
  "3 Years",
  "4 Years"
}

export enum Chinese_Survey10a {
  "Yes",
  "No"
}

export enum Chinese_Survey11a {
  "Yes",
  "No"
}

export enum Chinese_Survey12 {
  "Yes, all the time.",
  "Yes, often",
  "Yes, sometimes",
  "No"
}

export enum Chinese_Survey13 {
  "Yes, all the time.",
  "Yes, often",
  "Yes, sometimes",
  "No"
}

export enum Chinese_Survey14a {
  "Yes, hear and speak",
  "Yes, hear but not speak",
  "No"
}

export enum Chinese_Survey15 {
  "None",
  "10-50",
  "50-200",
  "200-500",
  "500-1000"
}

export enum Chinese_Survey16 {
  "None",
  "10-50",
  "50-200",
  "200-500",
  "500-1000"
}

export enum Chinese_Survey17 {
  "Yes, major",
  "Yes, minor",
  "Maybe",
  "No"
}

export enum Chinese_Survey18 {
  "Yes, major",
  "Yes, minor",
  "Maybe",
  "No"
}

export enum Chinese_Survey19 {
  "Yes",
  "No"
}

export enum Chinese_Survey20 {
  "Yes",
  "No"
}

export enum English_Camden_Survey1 {
  "A",
  "B",
  "C",
  "D"
}

export enum English_Camden_Survey2 {
  "I always speak English at home.",
  "I usually speak English at home.",
  "I sometimes speak English at home.",
  "I never speak English at home."
}

export enum English_Camden_Survey3 {
  "Yes, I read another languager better than English.",
  "No, I read English better than another language.",
  "I read English and another language with equal ability.",
  "I read only in English."
}

export enum English_Camden_Survey4 {
  "2 years or less",
  "3 to 5 years",
  "6 to 8 years",
  "9 years or more"
}

export enum English_Camden_Survey5 {
  "Yes, I write another languager better than English.",
  "No, I write English better than another language.",
  "I write in English and another language with equal ability.",
  "I write only in English."
}

export enum GermanNB_Survey {
  "1 year of German in middle or high school",
  "2 years of German in middle or high school",
  "3 years of German in middle or high school",
  "4 years of German in middle or high school",
  "5 years of German in middle or high school",
  "More than 5 years of German before college",
}

export enum Hindi_Survey {
  "A. Yes",
  "B. No"
}

export enum Italian_Survey1 {
  "Yes",
  "No"
}
